RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const SummaryItem = views.SummaryItem = Marionette.ItemView.extend({
        template: '#widgetMetricSummaryItemTemplate',
        tagName: 'tr',

        ui: {
            square: '.fa',
            icon: '.item-icon',
            popover: '[data-toggle="popover"]'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        className: function () {
            const me = this;
            const className = [];

            if (me.getOption('itemColumnSize')) {
                className.push(`col-sm-${me.getOption('itemColumnSize')}`);
            }

            if (me.model.getClassName()) {
                className.push(me.model.getClassName());
            }

            return className.join(' ');
        },

        templateHelpers: function () {
            const me = this;

            return App.utils.getSummaryTemplateHelpers(me, me.model);
        },

        onRender: function () {
            const me = this;

            if (me.getOption('disableColors')) {
                me.ui.square.addClass('hide');
            } else if (me.model.getColor()) {
                me.ui.square.css('color', me.model.getColor());
            }

            if (me.model.getIconTag) {
                const iconHTML = me.model.getIconTag();
                if (iconHTML) {
                    me.ui.icon.append(iconHTML);
                }
            }

            me.ui.popover.popover();
        }
    });

    views.SummaryItems = Marionette.CollectionView.extend({
        tagName: 'table',
        className: 'metric-legend',
        childView: SummaryItem,
        childViewOptions: function () {
            const me = this;

            return {
                disableColors: Boolean(me.getOption('disableColors')),
                itemColumnSize: me.getOption('itemColumnSize')
            };
        }
    });

    const GroupedSummaryItem = views.GroupedSummaryItem = SummaryItem.extend({
        tagName: 'li',
        template: '#widgetMetricSummaryGroupedItemTemplate'
    });

    views.GroupedSummaryItems = Marionette.CollectionView.extend({
        childView: GroupedSummaryItem,
        className: 'metric-summary-groups',
        attachHtml: function (collectionView, childView, index) {

            const me = this;

            if (index % me.getOption('group') === 0) {

                $('<ul />').addClass(me.getOption('groupClassName')).appendTo(collectionView.el);
            }

            childView.$el.appendTo(collectionView.el.querySelector('ul:last-child'));
        }
    });

});
